import Caliandra1 from '../Caliandra/Caliandra (1).webp'
import Caliandra2 from '../Caliandra/Calliandra (2).webp'
import Caliandra3 from '../Caliandra/Calliandra (3).webp'
import Caliandra4 from '../Caliandra/Calliandra (4).webp'
import Caliandra5 from '../Caliandra/Calliandra (5).webp'
import Caliandra6 from '../Caliandra/Calliandra (6).webp'



const Caliandraimages =[
Caliandra1,Caliandra2,Caliandra3,Caliandra4,Caliandra5,Caliandra6
]

export default Caliandraimages;